import {doppeActionTypeDefineViewerMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import React from 'react';
import {doppeActionTypeDownloadFilePreview} from './doppe-action-type-download-file-preview';

export const doppeActionTypeDownloadFilePreviewViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeDownloadFilePreview, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeDownloadFilePreviewWidget: (await import(
                './doppe-action-type-download-file-preview-widget/doppe-action-type-download-file-preview-widget'
            )).DoppeActionTypeDownloadFilePreviewWidget,
        };
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeDownloadFilePreviewWidget,
        } = viewerComponents;

        return (
            <DoppeActionTypeDownloadFilePreviewWidget
                {...renderProps}
            />
        );
    },
});
